.customTextContainer {
    margin-bottom: 20px;
}

.saveButtonContainer {
    display: flex;
    justify-content: end;
}